import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";
import { PermissionCheck } from "../../shared/permission";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { CanvasserTrackingDataProvider } from "../../data-provider/canvasser-tracking.dp";
import { Utils } from "../../helper/utils.helper";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { Campaign } from "../../models/campaign.model";
import { User } from "../../models/user.model";

let CanvasserTrackingComponent = {
    selector: "vcCanvasserTracking",
    templateUrl:
        "/angular/components/canvasser-tracking/canvasser-tracking.component.html",
    bindings: {},
    controller: class CanvasserTrackingController {
        private readonly $anchorScroll: any;
        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        private readonly $location: any;
        private readonly $timeout: any;

        private filter: any;
        private features: any = [];
        private localStorage: any;
        private permissionProvider: PermissionCheck;
        private teamDataProvider: TeamDataProvider;
        private dataProvider: CanvasserTrackingDataProvider;
        private effortDataProvider: EffortDataProvider;
        private resultDataProvider: ResultDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private firstLoad: string;
        private firstExpandComplete: boolean = false;

        public efforts: Effort[] = [];
        public __env: any;
        public screen: ScreenUtils;
        public team: any;
        public teams: any[];
        public overview: any;
        public customTemplates: any;
        public activeCampaign: Campaign;
        public loading: boolean = true;
        public userid: string | number;
        public users: User[];
        public markers: any[] = [];

        constructor(
            $scope: any,
            $location: any,
            $timeout: any,
            __env: any,
            $anchorScroll: any,
            PermissionCheck: PermissionCheck,
            TeamDataProvider: TeamDataProvider,
            CanvasserTrackingDataProvider: CanvasserTrackingDataProvider,
            EffortDataProvider: EffortDataProvider,
            ResultDataProvider: ResultDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            Utils: Utils,
            DialogUtils: DialogUtils,
            ScreenUtils: ScreenUtils
        ) {
            Utils.accessCheck();
            Utils.runWootric();

            this.$scope = $scope;
            this.$location = $location;
            this.$timeout = $timeout;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.screen = ScreenUtils;
            this.$anchorScroll = $anchorScroll;
            this.permissionProvider = PermissionCheck;
            this.resultDataProvider = ResultDataProvider;
            this.teamDataProvider = TeamDataProvider;
            this.dataProvider = CanvasserTrackingDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.customTemplates =
                this.resultDataProvider.getCustomDateTemplates();

            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.localStorage = this.activeCampaign.getLocalStorage();
            if (!this.localStorage.canvasserTracking) {
                this.localStorage.canvasserTracking = {};
            }

            this.filter = {
                app_type: "all",
                effort: null,
                team: "all",
                startDate: null,
                endDate: null,
            };

            if (this.localStorage.canvasserTracking.filter) {
                _.merge(
                    this.filter,
                    this.localStorage.canvasserTracking.filter
                );
                if (this.filter.dateRange) {
                    this.filter.dateRange.dateStart = new Date();
                    this.filter.dateRange.dateEnd = new Date();
                }
                this.setDateObj();
            } else {
                this.filter.dateRange = {
                    selectedTemplate: "TD",
                    selectedTemplateName: "Today",
                    dateStart: new Date(),
                    dateEnd: new Date(),
                };
                this.filter.dateRange.dateStart.setHours(0);
                this.filter.dateRange.dateStart.setMinutes(0);
                this.filter.dateRange.dateStart.setSeconds(0);
                this.filter.dateRange.dateStart.setMilliseconds(0);
            }

            this.filter.dateRange.dateStart = new Date(
                this.filter.dateRange.dateStart
            );
            this.filter.dateRange.dateEnd = new Date(
                this.filter.dateRange.dateEnd
            );

            this.permissionProvider.getFeaturePermissions().then((features) => {
                this.features = features;
                this.teamDataProvider.getAllTeams().then((teams) => {
                    this.teams = teams;
                    if (this.filter.team && this.filter.team.tid) {
                        this.filter.team = this.teamDataProvider.teamWithID(
                            this.filter.team.tid
                        );
                    } else {
                        if (
                            this.features.MANY_USERS &&
                            this.features.MANY_USERS.attributes
                                .organisationowner
                        ) {
                            this.filter.team = teams[0];
                        } else {
                            this.team = "all";
                        }
                    }

                    if (!this.firstLoad || this.firstLoad == "completed") {
                        setTimeout(() => {
                            this.loadData();
                        }, 50);
                    }
                });

                if (
                    !this.permissionProvider.hasPermission(
                        "CANVASSER_TRACKING_ALLOWED"
                    )
                ) {
                    let parentEl = angular.element(
                        document.getElementsByClassName(
                            "canvasser-tracking-page"
                        )
                    );
                    this.dialog.show({
                        parent: parentEl,
                        component: "vc-feature-restricted",
                        escapeToClose: false,
                        hasBackdrop: false,
                        clickOutsideToClose: false,
                        locals: {},
                        ariaLabel: "Feature Restricted",
                    });
                }
            });

            this.dataProvider.filter = this.filter;

            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;
                });
        }

        openInfoDialog(ev: any) {
            this.dialog.show({
                component: "vc-canvasser-tracking-info",
                locals: {},
                ariaLabel: "Info",
            });
        }

        setDateObj() {
            let templates = this.resultDataProvider.getCustomDateTemplates();
            angular.forEach(templates, (template) => {
                if (
                    template.name == this.filter.dateRange.selectedTemplateName
                ) {
                    this.filter.dateRange.dateStart = template.dateStart;
                    this.filter.dateRange.dateEnd = template.dateEnd;
                }
            });
        }

        $onInit() {
            this.$scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (this.teams && oldValue && newValue !== oldValue) {
                        let filter = angular.copy(this.filter);

                        if (filter.dateRange) {
                            delete filter.dateRange["dateStart"];
                            delete filter.dateRange["dateEnd"];
                        }

                        this.localStorage.canvasserTracking.filter = filter;
                        this.activeCampaign.localInfo = this.localStorage;
                        this.activeCampaign.saveLocalStorage();
                        this.$location.search(
                            "filter",
                            JSON.stringify(this.filter)
                        );
                        if (!this.firstLoad || this.firstLoad == "completed") {
                            this.dataProvider.clearMarkers(this.markers);
                            this.users = null;
                            this.loadData();
                        }
                    }
                },
                true
            );
        }

        loadData(): void {
            this.firstLoad = "started";
            if (
                this.permissionProvider.hasPermission(
                    "CANVASSER_TRACKING_ALLOWED"
                )
            ) {
                let data = _.cloneDeep(this.filter);

                if (data.team != "all" && (!data.team || !data.team.tid)) {
                    return;
                }

                this.loading = true;
                data.team = data.team == "all" ? data.team : data.team.tid;
                data.effortid = this.filter.effort
                    ? this.filter.effort.id
                    : null;
                this.dataProvider
                    .loadOverview(data)
                    .then((overview: object) => {
                        this.overview = overview;
                        this.loading = false;
                    });

                this.dataProvider.getAllUsers(this.filter).then(
                    (users: User[]) => {
                        this.users = users;
                        this.dataProvider.setMarkers(this.markers, this.users);

                        if (this.userid && !this.firstExpandComplete) {
                            this.firstExpandComplete = true;
                            this.dataProvider.expandUser(
                                this.users,
                                this.markers,
                                this.userid
                            );

                            this.$timeout(() => {
                                this.$location.hash("user-" + this.userid);
                                this.$anchorScroll();
                            }, 100);
                        }
                        this.firstLoad = "completed";
                    },
                    () => {
                        this.users = [];
                    }
                );
            } else {
                this.loading = false;
            }
        }
    },
};

angular
    .module("canvasserTracking")
    .component(CanvasserTrackingComponent.selector, CanvasserTrackingComponent);
